import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Ticket from '../../../shared/model/ticket/Ticket';
import { filterByProp } from '../../../shared/util/collection';
import TitleComponent from '../global/Title';

const Tickets = ({ tickets, ids }) => {
  const ticketsFiltered = useMemo(() => filterByProp(tickets, ids, 'id', 'name'), [
    tickets,
    ids
  ]);
  if (!ticketsFiltered) {
    return null;
  }
  return map(ticketsFiltered, (ticket) => (
    <TitleComponent key={ticket.id} title={ticket.getName()} trivial />
  ));
};

Tickets.propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.instanceOf(Ticket)).isRequired,
  ids: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
};

Tickets.defaultProps = {
  tickets: [],
  ids: []
};

export default Tickets;
